<template >
    <div class="w-100" id="idRecargosForm">
        <div v-if="load">
              <loading />

        </div>
        <div v-else class="w-100 my-3 recargosForm" >
            <div class="container-fluid" >

                <div class="row w-100">
                    <div class="col-4">
                      
                        <ui-select 
                            class="w-100" 
                            label="Tipo Recargo" 
                            placeholder="Seleccione"
                            :keys="{ value: 'id', label: 'name' }" 
                            :options="typeRecharges"
                            has-search
                            searchPlaceholder="Buscar"
                            v-model="typeRecharge"
                            :disabled="disabledForm"
                        />
                    </div>

                    <div class="col-4">
                        <ui-select 
                            class="w-100" 
                            label="Moneda" 
                            placeholder="Seleccione"
                            :keys="{ value: 'id', label: 'name' }" 
                            :options="currencies"
                            has-search
                            searchPlaceholder="Buscar"
                            v-model="currency"
                            :disabled="disabledForm"
                        />
                    </div>

                    <div class="col-4">

                        <div for="" class="ui-textbox__label-text"> Neta</div>

                        <input 
                            type="text" 
                            class="text_field_mask w-100"
                            v-mask="weightMask"
                            v-model="neta"
                            :disabled="disabledForm"

                        />
                    </div>

                </div>
                <div class="row w-100">
                    <div class="col-4">
                        <ui-select 
                            class="w-100" 
                            label="Naviera" 
                            placeholder="Seleccione"
                            :keys="{ value: 'id', label: 'name' }" 
                            :options="navieras" 
                            has-search 
                            searchPlaceholder="Buscar"
                            v-model="naviera"
                            :disabled="disabledForm"
                            @change="validationNavDeparture"
                        />
                    </div>
                    <div class="col-4">
                        <ui-select 
                            class="w-100" 
                            label="Naviera Salida" 
                            placeholder="Seleccione"
                            :keys="{ value: 'id', label: 'name' }" 
                            :options="navsDeparture" 
                            has-search 
                            searchPlaceholder="Buscar"
                            v-model="naviera_id_departure"
                            :disabled="disabledNavieraDeparture"
                        />
                    </div>

                    <div class="col-4">

                        <div for="" class="ui-textbox__label-text"> Venta (Pública)</div>

                        <input 
                            type="text" 
                            class="text_field_mask w-100"
                            v-mask="weightMask"
                            v-model="public_value"
                            :disabled="disabledForm"
                        />
                      
                    </div>
                    
                </div>

                <div class="row w-100">
                    <div class="col-4">
                        <ui-select 
                            class="w-100" 
                            label="POL" 
                            placeholder="Seleccione"
                            :keys="{ value: 'id', label: 'name' }" 
                            :options="ports" 
                            has-search 
                            searchPlaceholder="Buscar"
                            v-model="pol"
                            :disabled="disabledForm"
                        />
                    </div>

                    <div class="col-4">
                        <ui-select 
                            v-if="action == 'add'"
                            class="w-100" 
                            label="POD" 
                            placeholder="Seleccione"
                            :keys="{ value: 'id', label: 'name' }" 
                            :options="ports" 
                            has-search 
                            multiple
                            searchPlaceholder="Buscar"
                            v-model="pod"
                            :disabled="disabledForm"
                        />
                        <ui-select 
                            v-else
                            class="w-100" 
                            label="POD" 
                            placeholder="Seleccione"
                            :keys="{ value: 'id', label: 'name' }" 
                            :options="ports"
                            has-search 
                            searchPlaceholder="Buscar"
                            v-model="podModel"
                            :disabled="disabledForm"
                        />
                    </div>
                </div>

                <div class="row w-100">
                    <div class="col-4">
                        <label class="label-datepicker" >Desde</label>

                        <date-picker 
                            class=" w-100" 
                            format="YYYY-MM-DD" 
                            type="date" 
                            valueType="format"
                            v-model="from"
                            :disabled="disabledForm"
                        />
                    </div>

                    <div class="col-4">
                        <label class="label-datepicker" >Hasta</label>

                        <date-picker 
                            label="Hasta"
                            class="w-100" 
                            format="YYYY-MM-DD" 
                            type="date" 
                            valueType="format"
                            v-model="to"
                            :disabled="disabledForm"
                        />
                    </div>

                    <div class="col-4">

                        <ui-select 
                            class="w-100" 
                            label="Atmósfera" 
                            placeholder="Seleccione"
                            :keys="{ value: 'id', label: 'name' }" 
                            :options="atmosferas" 
                            has-search 
                            searchPlaceholder="Buscar"
                            v-model="atmosfera"
                            :disabled="disabledForm"
                        />
                    </div>
                
                </div>

                <div class="row w-100 mt-3">
                    <div class="col-4">
                        <ui-select 
                            class="w-100" 
                            label="Unidad" 
                            placeholder="Seleccione"
                            :keys="{ value: 'id', label: 'name' }" 
                            :options="containers" 
                            has-search 
                            searchPlaceholder="Buscar"
                            v-model="container"
                            :disabled="disabledForm"
                        />
                    </div>
                    <div class="col-4">
                        <ui-select 
                            class="w-100" 
                            label="Commodity" 
                            placeholder="Seleccione"
                            :keys="{ value: 'id', label: 'name' }" 
                            :options="products" 
                            has-search 
                            searchPlaceholder="Buscar"
                            v-model="commodity"
                            :disabled="disabledForm"
                        />
                    </div>
                    <div class="col-4">
                        <ui-select 
                            class="w-100" 
                            label="Unidad De Pago" 
                            placeholder="Seleccione"
                            :keys="{ value: 'id', label: 'name' }" 
                            :options="unityPayments" 
                            has-search 
                            searchPlaceholder="Buscar"
                            v-model="unityPayment"
                            :disabled="disabledForm"
                        />
                    </div>

                    
                </div>
            </div>
            <div class="container-fluid mt-3">
                <div class="row w-100">
                    <div class="col-3">
                        <button class="btn btn-default" @click="closeModal()" :disabled="disabledBtn">Cerrar</button>
                    </div>
                    <div class="col-9" v-if="!disabledForm">
                        <button 
                            v-if="action == 'add'"
                            class="btn btn-success float-right" 
                            @click="send()" 
                            :disabled="disabledBtn"
                        >
                            Agregar
                        </button>

                        <button 
                            v-if="action == 'update'"
                            class="btn btn-success float-right" 
                            @click="update()" 
                            :disabled="disabledBtn"
                        >
                            Actualizar
                        </button>

                        <button 
                            v-if="showReset"
                            class="btn btn-default float-right mr-3" 
                            @click="resetForm()" 
                            :disabled="disabledBtn"
                        >
                            Limpiar
                        </button>

                    </div>
                </div>
                
            </div>    
        </div>
    </div>
</template>

<script>

import { mapActions, mapState } from "vuex";

import { getSelectsRecargos, agregarRecargo, getRecargos, getRecharge,updateRecharge } from '../../../../../constants/lineas';

import DatePicker from "vue2-datepicker";

import Loading from "../../../../common/loading";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

const weightMask = createNumberMask({
  prefix: "",
  suffix: "",
  allowDecimal: true,
  requireDecimal: false,
  includeThousandsSeparator: false,
  decimalSymbol: ".",
  decimalLimit: 2,
  integerLimit: 9
});

export default {
    components: {
        DatePicker,
        Loading
    },
    computed: {

      ...mapState("lineas", ['dataDuplicarRecargoType']),

    },
    props: {
        closeModal :   { type: Function, default: () => {} },
        id :           { type: Number  , default: null },
        showReset :    { type: Boolean , default: true },
        action :       { type: String  , default: "add" },
        disabledForm : { type: Boolean , default: false },
    },
    data() {
        return {
            weightMask,
            naviera:{},
            naviera_id_departure : {},
            pol:{},
            pod:[],
            podModel:{},
            from: "",
            to: "",
            neta: "",
            public_value: "",
            atmosfera:{},
            container:{},
            commodity:{},
            unityPayment:{},
            currency:{},
            //selects
            navieras:[],
            ports:[],
            navsDeparture:[],
            atmosferas: [],
            containers: [],
            products:[],
            unityPayments:[],
            typeRecharge:{},
            typeRecharges:[],
            currencies:[],
            //acciones
            disabledBtn: false,
            load: false,
            disabledNavieraDeparture : false
        }
    },
    methods: {

        ...mapActions([ 'ActionSetLoadingTable']),
        ...mapActions("lineas", [
            "actionSetDataDatatableTarifasRecargos",
            'actionSetFiltroTypeRecharge',
            'actionSetFiltroNaviera',
            'actionSetFiltroPol',
            'actionSetFiltroPod',
            'actionSetFiltroAtmosfera',
            'actionSetFiltroContainer',
            'actionSetFiltroCommodity',
            'actionSetFiltroUnityPayment',
            'actionSetTariffRechargeDescription',
            'actionSetLogistaasOptions'
        ]),

        validationNavDeparture(){

            this.disabledNavieraDeparture = this.naviera.id == 39 ? false : true ;

            this.navsDeparture = this.naviera.id == 39 ? this.navieras.filter( pd => pd.id != 39 ) : this.navieras;

            this.naviera_id_departure = this.naviera.id == 39 ? {} : { id : this.naviera.id , name : this.naviera.name };

        },
        validForm(){

            if( !this.typeRecharge.id ){
                this.$vToastify.error("Tipo Recargo requerido", "¡Error!");
                return false ;
            }
            if( !this.currency.id ){
                this.$vToastify.error("Campo Moneda requerido", "¡Error!");
                return false ;
            }
            if( !this.naviera.id ){
                this.$vToastify.error("Campo Naviera requerido", "¡Error!");
                return false ;
            }

            if( !this.naviera_id_departure.id ){
                this.$vToastify.error("Campo Naviera Salida requerido", "¡Error!");
                return false ;
            }

            if( this.action == "update" ){
                if( !this.podModel.id ){
                    this.$vToastify.error("Campo POD requerido", "¡Error!");
                    return false ;
                }
            } else {
                if( !this.pod.length ){
                    this.$vToastify.error("Campo POD requerido", "¡Error!");
                    return false ;
                }
            }

            if( !this.from ){
                this.$vToastify.error("Campo Desde requerido", "¡Error!");
                return false ;
            }

            if( !this.to ){
                this.$vToastify.error("Campo Hasta requerido", "¡Error!");
                return false ;
            }

            if( !this.public_value ){
                this.$vToastify.error("Campo public_value (Pública) requerido", "¡Error!");
                return false ;
            }

            if( !this.pol.id ){
                this.$vToastify.error("Campo 'POL' requerido", "¡Error!");
                return false ;
            }
            
            if( !this.neta ){
                this.$vToastify.error("Campo Neta (Costo) requerido", "¡Error!");
                return false ;
            }

            if( !this.container.id ){
                this.$vToastify.error("Campo Container requerido", "¡Error!");
                return false ;
            }

            if( !this.unityPayment.id ){
                this.$vToastify.error("Campo Unidad De Pago requerido", "¡Error!");
                return false ;
            }

            if( this.public_value.toString().includes(",") || this.neta.toString().includes(",") ){
                this.$vToastify.error("Lo valores decimales para 'Neta' y 'Venta (Pública)' deben ser un punto.", "¡Error!");
                return false ;
            }

            return true ;
        },
        async send(){
            const valid = this.validForm();

            if( !valid ) return ; 

            this.disabledBtn = true ;

            const tariff_recharges = this.pod.map( p => ({
                tariff_recharges_type : this.typeRecharge.id ?? null,
                naviera_id : this.naviera.id ?? null,
                naviera_id_departure : this.naviera_id_departure.id ?? null,
                currency_id : this.currency.id ?? null,
                pol        : this.pol.id ?? null,
                pod        : p.id ?? null,
                from       : this.from ?? null,
                to         : this.to ?? null,
                neta       : this.neta ?? null,
                public_value       : this.public_value ?? null,
                products_category_id : this.commodity.id ?? null,
                atmosphere_id   : this.atmosfera.id ?? null,
                container_id    : this.container.id ?? null,
                unit_payment    : this.unityPayment.id ?? null
            }));

            const form = { tariff_recharges };

            this.$vToastify.loader("Agregando Recargo...");

            try {
                await  agregarRecargo( form ) ;

                this.$vToastify.stopLoader();
                this.closeModal();
                this.$vToastify.success("Recargo creado con éxito", "Éxito");
                this.disabledBtn = false ;
                this.resetForm();
                this.getRecargos();

            } catch (error) {
                this.$vToastify.stopLoader();
                this.$vToastify.error(
                    "Error al Crear Recargo. Por favor recargue y vuelva a intentar",
                    "Error"
                );
                this.disabledBtn = false ;
            }

        },
        resetForm (){
            this.typeRecharge = {} ;
            this.naviera = {} ;
            this.naviera_id_departure = {} ;
            this.pol  = {} ;
            this.pod  = [] ;
            this.from =  "";
            this.to   =  "";
            this.neta =  "";
            this.public_value =  "";
            this.atmosfera = {} ;
            this.container = {} ;
            this.commodity = {} ; 
            this.unityPayment = {} ;
            this.currency = {} ;
        },
        async init(){
            const { data } = await getSelectsRecargos() ;

            this.navieras       = data.navieras ;
            this.ports          = data.ports ;
            this.navsDeparture  = data.navieras ;
            this.containers     = data.containers ;

            this.atmosferas     = data.atmosferas ;
            this.products       = data.commodity ;
            this.unityPayments  = data.unityPayments ;
            this.typeRecharges  = data.rechargeTypes ;
            this.currencies     = data.currencies.map( c => ({id : c.id, name: c.name }) ) ;

            this.actionSetTariffRechargeDescription( data.descriptions ) ;

            this.actionSetLogistaasOptions( data.logistaasRecharges )
        },

        async getRecargos(){

            this.ActionSetLoadingTable(true);

            const { data } = await getRecargos() ;

            const data_table = !data.data ? [] : data.data.map( d => ({
                data: [
                    d.naviera_name,
                    d.naviera_departure,
                    d.name,
                    d.code,
                    d.pol_name,
                    d.pod_name,
                    d.from_format,
                    d.to_format,
                    d.currency_name,
                    d.neta,
                    d.public_value, 
                    d.atmosphere_name,
                    d.container_name,
                    d.products_category_name,
                    d.unit_payment_name
                ],
                data_complementaria: d
            })) ;
            const { 
                filtroAtmosfera,
                filtroContainers,
                filtroNavieras,
                filtroPod,
                filtroPol,
                filtroTypeRecharge,
                filtroCommodity,
                filtroUnidadPago
            } = data.filtros ;

            this.actionSetFiltroTypeRecharge( filtroTypeRecharge );
            this.actionSetFiltroNaviera( filtroNavieras );
            this.actionSetFiltroPol( filtroPol );
            this.actionSetFiltroPod( filtroPod );

            this.actionSetFiltroAtmosfera( filtroAtmosfera );
            this.actionSetFiltroContainer( filtroContainers );
            this.actionSetFiltroCommodity( filtroCommodity );
            this.actionSetFiltroUnityPayment( filtroUnidadPago );

            this.actionSetDataDatatableTarifasRecargos( data_table );
            this.ActionSetLoadingTable(false);

        },

        async getRecharge( id ){
            const { data } = await getRecharge( id );
            return data ;
        },
        async setDatarecharge( id ){
            this.load = true ;
            const data = await this.getRecharge( id );
            this.setData( data ) ;
            this.load = false ;
        },
        setData( data , duplicate = false ){
            this.validationNavDeparture() ;

            this.typeRecharge = {
                id : data.recharges_type_id,
                name : data.recharges_type_name_code,
            };

            this.currency = {
                id : + data.currency_id,
                name : data.currency_name,
            };

            this.naviera = {
                id : data.naviera_id,
                name : data.naviera_name,
            };

            this.naviera_id_departure = {
                id : data.naviera_id_departure,
                name : data.naviera_departure,
            };

            this.pol = {
                id : data.pol,
                name : data.pol_name,
            };

            this.podModel = {
                id : data.pod,
                name : data.pod_name,
            };
            
            this.from = data.from;
            this.to = data.to;
            
            this.neta = data.neta;
            this.public_value = +data.public_value.toString();

            this.atmosfera = {
                id : data.atmosphere_id,
                name : data.atmosphere_name
            };

            if( duplicate ){
                this.pod = [ {
                    id : data.pod,
                    name : data.pod_name,
                }];
            }

            this.container = {
                id : data.container_id,
                name : data.container_name
            };

            this.commodity = {
                id : data.products_category_id,
                name : data.products_category_name
            };

            this.unityPayment = {
                id : data.unit_payment,
                name : data.unit_payment_name
            };

            this.disabledNavieraDeparture = this.naviera.id == 39 ? false : true ;
        },
        async update(){
            const valid = this.validForm();

            if( !valid ) return ; 

            this.disabledBtn = true ;

            const form = {
                id : this.id ?? null,
                tariff_recharges_type : this.typeRecharge.id ?? null,
                naviera_id : this.naviera.id ?? null,
                naviera_id_departure : this.naviera_id_departure.id ?? null,
                currency_id : this.currency.id ?? null,
                pol        : this.pol.id ?? null,
                pod        : this.podModel.id ?? null,
                from       : this.from ?? null,
                to         : this.to ?? null,
                neta       : this.neta ?? null,
                public_value      : this.public_value ?? null,
                products_category_id : this.commodity.id ?? null,
                atmosphere_id   : this.atmosfera.id ?? null,
                container_id    : this.container.id ?? null,
                unit_payment    : this.unityPayment.id ?? null
            } ;

            this.$vToastify.loader("Actualizando Recargo...");

            try {
                await  updateRecharge( form ) ;

                this.$vToastify.stopLoader();
                this.closeModal();
                this.$vToastify.success("Recargo actualizado con éxito", "Éxito");
                this.disabledBtn = false ;
                this.getRecargos();

            } catch (error) {
                
                this.disabledBtn = false ;
                this.$vToastify.stopLoader();
                this.$vToastify.error(
                    "Error al actualizar Recargo. Por favor recargue y vuelva a intentar",
                    "Error"
                );
            }
        }

    },

    created() {
        this.init();
    },
    watch: {
        id: function (_new) {
            if( _new ) this.setDatarecharge( _new);
        },
        dataDuplicarRecargoType: function (_new) {
            if( _new ){
                this.setData( _new.data_complementaria, true );
                // this.to   =  "";
                // this.from =  "";
            }
        },
    }
}
</script>

<style>

    
    #idRecargosForm .text_field_mask {
        background: none;
        border: none;
        border-bottom-color: rgba(0, 0, 0, 0.12);
        border-bottom-style: solid;
        border-bottom-width: 1px;
        border-radius: 0;
        color: rgba(0, 0, 0, 0.87);
        cursor: auto;
        display: block;
        font-family: inherit;
        font-size: 1rem;
        font-weight: normal;
        margin: 0;
        outline: none;
        padding: 0;
        transition: border 0.1s ease;
        width: 100%;
        height: 32px;
    }
    .recargosForm .container-fluid .mx-input{
        border: 0px;
        border-bottom: 1px solid #ccc;
        box-shadow: none;
        border-radius: 0px;
    }

    .recargosForm .container-fluid .label-datepicker{
        color: rgba(0, 0, 0, 0.54);
        font-size: 0.9375rem;
        font-weight: 700 !important;
        margin-bottom: 0px;
    }

    .recargosForm .container-fluid .ui-select__label ,
    .recargosForm .container-fluid .ui-textbox__label-text ,
    .recargosForm .container-fluid .ui-select.is-disabled .ui-select__display{
        color: rgba(0, 0, 0, 0.54);
        font-weight: 700;
        background-color: unset;
    }

    .recargosForm .container-fluid .mx-input:disabled, 
    .recargosForm .container-fluid .ui-select.is-disabled .ui-select__display {
        color: rgba(0, 0, 0, 0.54) !important;
        background-color: unset;
        font-weight: 100 !important
    }

</style>